<template>
  <div class="column">
    <div class="container container_com-fundo container_com-margem">
      <div class="columns search buscar-solicitacoes no-print">
        <form @submit.prevent="obterCotas(1)" class="formulario">
          <div class="grade__linha grade__linha_alinhar-vertical-a-base">
            <div class="grade__coluna grade__coluna_3">
              <label for="projeto">Projeto</label>
              <select
                id="projeto"
                name="projeto"
                v-model="projeto">
                <option v-for="projeto in projetos" :value="projeto.Id">
                  {{ projeto.Nome }}
                </option>
              </select>
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label for="empreendimento">Município</label>
              <input
                v-model="nomeDaCidade"
                id="nomeDaCidade"
                name="nomeDaCidade"
                type="text"
                maxlenght="90"
                placeholder="Ex: Campo Grande"
              />
            </div>
          </div>
          <div class="grade__linha grade__linha_alinhar-vertical-a-base">
            <div class="grade__coluna grade__coluna_1">
              <button type="submit" class="botao botao_cinza botao_grande">
                Filtrar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="container container_com-fundo container_com-margem">
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="columns search buscar-solicitacoes no-print">
        <div class="column control">
          <router-link :to="{ name: 'CadastrarCota' }" class="botao botao_medio botao_cor-terciaria">
            <span>Nova cota</span>
          </router-link>
        </div>
      </div>
      <table class="tabela tabela_listrada tabela_com-largura-total">
        <thead>
          <tr>
            <th>Município</th>
            <th>Projeto</th>
            <th class="u-texto-alinhado-ao-centro">Cotas</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cota of cotas" v-if="cotas.length > 0" :id="cota.Id">
            <td>
              {{ cota.CidadeNome }}
            </td>
            <td>
              {{ cota.ProjetoNome }}
            </td>
            <td class="u-texto-alinhado-ao-centro">
              {{cota.QuantidadeUsada}} /{{cota.Quantidade}}
            </td>
            <td class="ver-detalhes no-print">
              <div>
                <button type="button" @click="redirecionarParaVisualizacao(cota.Id)" class="botao botao_cor-terciaria botao_contorno botao_pequeno">Visualizar</button>
              </div>
            </td>
          </tr>
          <tr v-if="cotas.length === 0">
            <td colspan="6">
              Nenhuma cota encontrada
            </td>
          </tr>
        </tbody>
      </table>
      <paginacao @paginar="obterCotas" :paginaAtual="paginaAtual" :totalDePaginas="totalDePaginas" :totalDeRegistros="totalDeRegistros"/>
    </div>
  </div>
</template>

<script>
import Loading from '../shared/Loading';
import Alerta from '../shared/Alerta';
import Paginacao from "../shared/Paginacao";

export default {
  name: 'lista-de-cotas',
  components: { Loading, Alerta, Paginacao },
  data() {
    return {
      cotas: this.cotas || [],
      projeto: null,
      projetos:[],
      nomeDaCidade: null,
      paginaAtual: 0,
      totalDePaginas: null,
      totalDeRegistros: null,
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
    };
  },
  created() {
    this.obterCotas(1);

    this.$api
      .get("/Projeto/ObterVigentes")
      .then((response) => {
        this.projetos = [{ Id: null, Nome: "Selecione o projeto" }];
        this.projetos = this.projetos.concat(response.data);

        return response;
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    obterCotas(pagina) {
      this.exibirCarregamento();
      const filtro = {
        pagina: pagina,
        projetoId: this.projeto,
        nomeDaCidade: this.nomeDaCidade,
      };

      this.$api.post('/Cotas/ObterPaginados', filtro)
        .then((response) => {
          this.esconderCarregamento();
          this.cotas = response.data.Modelo;
          this.paginaAtual = response.data.PaginaAtual;
          this.totalDePaginas = response.data.TotalDePaginas;
          this.totalDeRegistros = response.data.TotalDeRegistros;
          this.loading.visivel = false;
        }).catch((error) => {
          this.esconderCarregamento();
          this.tratarErro(error);
        });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
      window.scrollTo(0, 0);
    },
    exibirMensagemDeSucesso(mensagem) {
      this.tipoDeAlerta = 'success';
      this.mensagemDeAlerta = mensagem;
      window.scrollTo(0, 0);
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = 'erro';
      const mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta = mensagensDeErro || 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';
    },
    redirecionarParaVisualizacao(cotaId) {
      this.$router.push({ name: 'VisualizarCota', query: { idDaCota: cotaId } });
    }
  },
};
</script>



// WEBPACK FOOTER //
// ListaDeCotas.vue?44ca0d48